import { StyleSheet, Text, View, TouchableOpacity } from 'react-native';
import React, { FC, useMemo, useState } from 'react';
import { Image } from '../../../components/Image';
import { STYLE_VARS } from '../../../constants/style-vars';
import WeekDaySelect from './WeekDaySelect';
import SportCoachingForm from './SportCoachingForm';
import { useIsDesktop } from '../../../hooks/useIsDeskTop';
import { FONTS } from '../../../constants';
import { NavigationService } from '../../../services/navigation';

const SportCoaching: FC = () => {
  const [selectedDay, setSelectedDay] = useState<string[]>([]);
  const isDesktop = useIsDesktop();
  const renderHeader = useMemo(() => {
    if (isDesktop()) {
      return (
        <View
          style={{
            paddingBottom: 20,
            borderBottomColor: STYLE_VARS.fccDarkGrey,
            borderBottomWidth: 1,
            marginBottom: 30,
            flexDirection: 'row',
            justifyContent: 'space-between',
          }}
        >
          <View
            style={{
              flexDirection: 'row',
              alignItems: 'center',
            }}
          >
            <Image
              source={require('../../../assets/book-sports-coaching.png')}
              style={{
                width: 24,
                height: 24,
                resizeMode: 'contain',
                marginRight: 10,
              }}
            />
            <Text
              style={{
                fontSize: 18,
                fontFamily: FONTS.IowanOldStyleBTRoman,
                color: STYLE_VARS.textColor,
                fontWeight: '500',
              }}
            >
              SPORTS COACHING
            </Text>
          </View>
          <TouchableOpacity
            style={{ flexDirection: 'row', alignItems: 'center' }}
            onPress={() => {
              NavigationService.push<'Root'>('Root', {
                screen: 'MenuTab',
                params: {
                  screen: 'Sports',
                  params: {
                    screen: 'Facility',
                  },
                },
              });
            }}
          >
            <Text
              style={{
                fontSize: isDesktop() ? 14 : 12,
                fontFamily: FONTS.AvenirMedium,
                color: STYLE_VARS.textColor,
                fontWeight: '500',
                marginRight: 5,
              }}
            >
              BACK
            </Text>
            <Image
              source={require('../../../assets/sport-back-button.png')}
              style={{
                width: 16,
                height: 16,
                resizeMode: 'contain',
                marginRight: 5,
              }}
            />
          </TouchableOpacity>
        </View>
      );
    }
    return (
      <View style={{ paddingVertical: 20 }}>
        <View
          style={{
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Image
            source={require('../../../assets/book-sports-coaching.png')}
            style={{
              width: 24,
              height: 24,
              resizeMode: 'contain',
              marginRight: 10,
            }}
          />
          <Text
            style={{
              fontSize: 18,
              fontFamily: FONTS.IowanOldStyleBTRoman,
              color: STYLE_VARS.textColor,
              fontWeight: '500',
            }}
          >
            SPORTS COACHING
          </Text>
        </View>
      </View>
    );
  }, [isDesktop]);

  return (
    <View>
      {renderHeader}
      <View style={!isDesktop() && styles.container}>
        <SportCoachingForm />
      </View>
    </View>
  );
};

export default SportCoaching;

const styles = StyleSheet.create({
  container: {
    paddingHorizontal: 20,
  },
});
